export default "__VITE_ASSET__9nUR1vrz__"